<template>
    <footer>
        <div class="container">
             <div class="row">
                <div class="order-lg-1 col-md-6 col-lg-12">
                    <div class="row">
                        <div class="col-lg-6">
                            <h2 class="logo">{{ company }}</h2>
                            <p>Member of the C-Suite Group</p>
                        </div>
                        <address class="col-lg-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.868" height="15.533" viewBox="0 0 12.868 15.533"><g transform="translate(-5.885 -1.104)"><path class="a" d="M6.434,15.533h0L1.884,10.984a6.435,6.435,0,0,1,9.1-9.1,6.434,6.434,0,0,1,0,9.1L6.435,15.533Zm0-12.153A2.987,2.987,0,1,0,9.421,6.369,2.991,2.991,0,0,0,6.433,3.381Z" transform="translate(5.885 1.104)"/></g></svg>
                            <a href="https://goo.gl/maps/gqoLZdozLBNnsjLcA" target="_blank" rel="noopener">
                                36 Sam Leong Road, <br>Singapore 357741
                            </a>
                        </address>
                    </div>
                </div>
                <div class="order-lg-3 col-md-6 social-media">
                    <a href="https://www.facebook.com/csuitecircle" target="_blank" tabindex="-1" rel="noopener">
                        <i aria-label="facebook"><img src="https://img.icons8.com/ios-filled/30/b5c0c7/facebook-f.png" alt="" /></i>
                    </a>
                    <a href="https://www.linkedin.com/company/csuitecircle/" target="_blank" tabindex="-1" rel="noopener">
                        <i aria-label="linkedin"><img src="https://img.icons8.com/ios-filled/30/b5c0c7/linkedin-2.png" alt="" /></i>
                    </a>
                    <a href="https://twitter.com/csuitecircle" target="_blank" tabindex="-1" rel="noopener">
                        <i aria-label="twitter"><img src="https://img.icons8.com/ios-filled/30/b5c0c7/twitter.png" alt="" /></i>
                    </a>
                </div>
                <div class="order-lg-2 col-md-12 col-lg-6 legal">
                    <div class="row">
                        <div class="order-md-2 order-lg-1 col-md-6 col-lg-12 text-md-right text-lg-left">
                            <ul class="list-unstyled mb-1">
                                <li class="mr-3">
                                    <a href="https://www.csuitecircle.com/privacy.html" target="_blank" rel="noopener">Privacy Policy</a>
                                </li>
                                <li>
                                    <a href="https://www.csuitecircle.com/privacy.html" target="_blank" rel="noopener">Terms &amp; Conditions</a>
                                </li>
                            </ul>
                        </div>
                        <div class="order-md-1 order-lg-2 col-md-6 col-lg-12">
                            <p class="copy-text">{{ displayCopyright }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'app-footer',

    data() {
        return {
            currentYear: new Date().getFullYear(),
            company: 'C-Suite Labs',
        };
    },

    computed: {
        displayCopyright() {
            return `© ${this.currentYear} The C-Suite Group. All Rights Reserved.`;
        },
    },
};
</script>

<style lang="scss" scoped>
$footer-text-color: #b5c0c7;
$footer-text-color-hover: #ffffff;

footer {
    background-color: $black;
    padding: 40px 0 30px;
    color: $footer-text-color;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
}

@media (min-width:768px) {
    footer {
        text-align: left;
    }
}

@media (min-width:992px) {
    footer {
        padding: 40px 0 30px;
    }
}

footer a {
    color: $footer-text-color;
    text-decoration: none;
    font-weight: 600;
}

footer a:hover {
    color: $footer-text-color-hover;
    text-decoration: none;
}

footer a i img:hover {
    filter: brightness(1.5);
}

footer i {
    color: $footer-text-color;
    font-size: 30px;
    padding: 0 15px;
}

footer .logo {
    font-size: 30px;
    font-weight: 800;
    color: $primary;
    margin-bottom: 25px;
}

@media (min-width:768px) {
    footer .logo {
        margin-bottom: 10px;
    }
}

footer address a {
    font-weight: 500;
}

@media (min-width:768px) {
    footer address {
        margin-bottom: 30px;
    }
}

@media (min-width:992px) {
    footer address {
        display: flex;
        justify-content: flex-end;
    }
}

footer address svg {
    display: none;
}

@media (min-width:992px) {
    footer address svg {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        margin-top: 5px;
    }
}

footer address svg path {
    fill: $footer-text-color;
}

footer .social-media {
    margin-bottom: 50px;
}

@media (min-width:768px) {
    footer .social-media {
        margin-bottom: 30px;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }
}

@media (min-width:992px) {
    footer .social-media {
        margin-bottom: 0;
    }
}

footer .legal {
    font-size: 15px;
}

footer .legal ul li {
    position: relative;
    display: inline-block;
}

@media (min-width:992px) {
    footer .legal ul li:first-of-type:after {
        content: "/";
        position: absolute;
        top: 1px;
        right: -11px;
        color: $footer-text-color;
    }
}

footer .legal .copy-text {
    margin-bottom: 0;
    opacity: 0.7;
}
</style>
